var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 14.7335L17.225 8.34186C17.4236 8.14325 17.6764 8.04395 17.9834 8.04395C18.2903 8.04395 18.5431 8.14325 18.7417 8.34186C18.9403 8.54047 19.0396 8.79325 19.0396 9.10019C19.0396 9.40714 18.9403 9.65992 18.7417 9.85853L11.5917 17.0085C11.375 17.2252 11.1223 17.3335 10.8334 17.3335C10.5445 17.3335 10.2917 17.2252 10.075 17.0085L7.25837 14.1919C7.05975 13.9933 6.96045 13.7405 6.96045 13.4335C6.96045 13.1266 7.05975 12.8738 7.25837 12.6752C7.45698 12.4766 7.70975 12.3773 8.0167 12.3773C8.32364 12.3773 8.57642 12.4766 8.77503 12.6752L10.8334 14.7335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2a1c6ca5c32b970e7676b917fd70091a.svg";
export { ForwardRef as ReactComponent };